import React from 'react';
import PropTypes from 'prop-types';
// import styles from './styles.scoped.css';

export default function LoadingBars(
  {
    className = '',
    size = 2
  }
) {
  const remSize = `${size}rem`;
  const customClass = ['root', className].filter(Boolean).join(' ');

  return (
    <div className={customClass} style={{ height: remSize, width: remSize }}>
      <span /><span /><span />
    </div>
  );
}

LoadingBars.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
};
